"use strict";
Object.defineProperty(exports, Symbol.toStringTag, { value: "Module" });
const react = require("react");
const useThrottledState = require("./useThrottledState.cjs");
function useThrottledValue(value, options, selector) {
  const [throttledValue, setThrottledValue, throttler] = useThrottledState.useThrottledState(
    value,
    options,
    selector
  );
  react.useEffect(() => {
    setThrottledValue(value);
  }, [value, setThrottledValue]);
  return [throttledValue, throttler];
}
exports.useThrottledValue = useThrottledValue;
//# sourceMappingURL=useThrottledValue.cjs.map
